import { render, staticRenderFns } from "./RecipeView.vue?vue&type=template&id=11dd69d8&scoped=true"
import script from "./RecipeView.vue?vue&type=script&lang=js"
export * from "./RecipeView.vue?vue&type=script&lang=js"
import style0 from "./RecipeView.vue?vue&type=style&index=0&id=11dd69d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11dd69d8",
  null
  
)

export default component.exports